import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

// Şifre validasyon fonksiyonu
const validatePassword = (password) => {
    const minLength = password.length >= 8;
    const hasLowercase = /[a-z]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecial = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password);

    return {
        minLength,
        hasLowercase,
        hasUppercase,
        hasNumber,
        hasSpecial,
        isValid: minLength && hasLowercase && hasUppercase && hasNumber && hasSpecial
    };
};

export default function UpdatePasswordDiaolog({ visible, onHide, onSubmit, toast }) {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const passwordValidation = validatePassword(password);

    const handleSubmit = () => {
        if (!passwordValidation.isValid) {
            if (toast?.current) {
                toast.current.show({ severity: 'warn', summary: 'Uyarı', detail: 'Şifre gereksinimleri karşılanmıyor.' });
            }
            return;
        }

        if (password !== confirmPassword) {
            if (toast?.current) {
                toast.current.show({ severity: 'warn', summary: 'Uyarı', detail: 'Şifreler eşleşmiyor.' });
            }
            return;
        }

        onSubmit(password);
    };

    const handleClose = () => {
        onHide();
        setPassword('');
        setConfirmPassword('');
    };

    return (
        <Dialog
            header="Şifre Değiştir"
            visible={visible}
            style={{ width: '450px' }}
            onHide={handleClose}
            footer={
                <div className="flex justify-content-end gap-2">
                    <Button label="İptal" icon="pi pi-times" severity="secondary" onClick={handleClose} />
                    <Button icon="pi pi-check" label="Onayla" onClick={handleSubmit} disabled={!passwordValidation.isValid || password !== confirmPassword} />
                </div>
            }
        >
            <div className="flex flex-column gap-3">
                {/* Yeni Şifre */}
                <div className="p-inputgroup">
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-lock"></i>
                    </span>
                    <InputText type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Yeni Şifre" className="w-full" />
                    <span className="p-inputgroup-addon cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                        <i className={showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'}></i>
                    </span>
                </div>

                {/* Şifre Tekrar */}
                <div className="p-inputgroup">
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-lock"></i>
                    </span>
                    <InputText type={showConfirmPassword ? 'text' : 'password'} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Şifre Tekrar" className="w-full" />
                    <span className="p-inputgroup-addon cursor-pointer" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                        <i className={showConfirmPassword ? 'pi pi-eye-slash' : 'pi pi-eye'}></i>
                    </span>
                </div>

                {/* Şifre eşleşme kontrolü */}
                {confirmPassword && password !== confirmPassword && (
                    <small className="text-red-500">
                        <i className="pi pi-times mr-1"></i>
                        Şifreler eşleşmiyor
                    </small>
                )}

                {/* Şifre Gereksinimleri */}
                <div className="text-sm">
                    <p className="m-0 mb-2 font-semibold">Şifre Gereksinimleri:</p>
                    <ul className="m-0 pl-4" style={{ listStyle: 'none' }}>
                        <li className={passwordValidation.minLength ? 'text-green-500' : 'text-red-500'}>
                            <i className={`pi ${passwordValidation.minLength ? 'pi-check' : 'pi-times'} mr-2`}></i>
                            En az 8 karakter
                        </li>
                        <li className={passwordValidation.hasLowercase ? 'text-green-500' : 'text-red-500'}>
                            <i className={`pi ${passwordValidation.hasLowercase ? 'pi-check' : 'pi-times'} mr-2`}></i>
                            En az 1 küçük harf (a-z)
                        </li>
                        <li className={passwordValidation.hasUppercase ? 'text-green-500' : 'text-red-500'}>
                            <i className={`pi ${passwordValidation.hasUppercase ? 'pi-check' : 'pi-times'} mr-2`}></i>
                            En az 1 büyük harf (A-Z)
                        </li>
                        <li className={passwordValidation.hasNumber ? 'text-green-500' : 'text-red-500'}>
                            <i className={`pi ${passwordValidation.hasNumber ? 'pi-check' : 'pi-times'} mr-2`}></i>
                            En az 1 rakam (0-9)
                        </li>
                        <li className={passwordValidation.hasSpecial ? 'text-green-500' : 'text-red-500'}>
                            <i className={`pi ${passwordValidation.hasSpecial ? 'pi-check' : 'pi-times'} mr-2`}></i>
                            En az 1 özel karakter (!@#$%^&* vb.)
                        </li>
                    </ul>
                </div>
            </div>
        </Dialog>
    );
}
